import { render } from "./VerificacionCorreo.vue?vue&type=template&id=00306648&scoped=true"
import script from "./VerificacionCorreo.vue?vue&type=script&lang=js"
export * from "./VerificacionCorreo.vue?vue&type=script&lang=js"

import "./VerificacionCorreo.vue?vue&type=style&index=0&id=00306648&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00306648"]])

export default __exports__